module.exports = __webpack_public_path__ + "static/media/whitelogo.a0d91bfe.svg";